import React, { useCallback, useEffect, useState } from "react";
import { Affix, Button, Icon, Tooltip } from "antd";
import { Switch, Route, Link, useRouteMatch } from "react-router-dom";

import VotingForm from "./containers/new-voting/new-voting";
import VotingItem from "./containers/voting-item/voting-item";
import VotingsList from "./containers/votings-list/votings-list";

import appSettings from "../../constants/app.constants";
import useLoadAddresses from "./hooks/useLoadAddresses";

import "./container.scss";

const VotingPage = () => {
	const [height, setHeight] = useState(0);
	const match = useRouteMatch("/Voting/:page") || { params: {} };
	const {
		params: { page },
	} = match;

	useLoadAddresses();

	const listener = useCallback(() => {
		setHeight(window.innerHeight - appSettings.windowHeightDelta);
	}, [window.innerHeight, appSettings.windowHeightDelta]);

	useEffect(() => {
		setHeight(window.innerHeight - appSettings.windowHeightDelta);
		window.addEventListener("resize", listener);

		return () => {
			window.removeEventListener("resize", listener);
		};
	}, []);
	const votingItemOpened = Number(page) || null;
	return (
		<>
			{votingItemOpened && (
				<Affix
					className="dispex-filter-button"
					offsetTop={10}
					style={{ zIndex: 15 }}
				>
					<div>
						<Link to="/Voting/new">
							<Tooltip title="Новый опрос" placement="bottom">
								<Button
									type="primary"
									shape="circle"
									icon="plus"
									style={{ marginRight: "10px" }}
								/>
							</Tooltip>
						</Link>
					</div>
				</Affix>
			)}
			<div className="Voting__container">
				<div className="Voting__left-block">
					<VotingsList height={height} />
				</div>
				<div className="Voting__right-block">
					<Switch>
						<Route exact path={"/Voting/new"}>
							<VotingForm height={height} />
						</Route>
						<Route path={"/Voting/:id"}>
							<VotingItem height={height} />
						</Route>
						<Route exact path={"/Voting"}>
							<div className="Voting__right-block-new__container">
								<Link to="/Voting/new">
									<div className="Voting__right-block-new__icon">
										<Icon type="plus" style={{ color: "rgb(196, 196, 196)" }} />
									</div>
								</Link>
							</div>
						</Route>
					</Switch>
				</div>
			</div>
		</>
	);
};

export default VotingPage;
